import { render } from "./subheadline.vue?vue&type=template&id=7f95a3c0"
import script from "./subheadline.vue?vue&type=script&lang=js"
export * from "./subheadline.vue?vue&type=script&lang=js"

import "./subheadline.vue?vue&type=style&index=0&id=7f95a3c0&lang=scss"

import exportComponent from "C:\\Users\\chbo\\Documents\\repos\\semco-maritime-touchkit\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__